
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import store from './store/store'
import App from './App';
import reportWebVitals from './reportWebVitals';
import MainCookieConsent from "./components/common/main-cookie-consent";
import ReactGA from 'react-ga';
import { CookiesProvider } from 'react-cookie';


ReactGA.initialize('G-PM76J3TN02');

ReactDOM.render(
    <Provider store={store}>
        <React.StrictMode>
            <CookiesProvider>
                <App />
                <MainCookieConsent></MainCookieConsent>
            </CookiesProvider>
        </React.StrictMode>
    </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
